import { staffRoleLabel } from '../../admin-shared/staffRoleOptions';

export function isStaffOnDeskLeave(person) {
  return person?.desk_available === false;
}

export function staffDeskUnavailable(person, occupiedStylistIds) {
  const occupied = occupiedStylistIds?.has?.(String(person?.id));
  return Boolean(occupied || isStaffOnDeskLeave(person));
}

export function staffDeskPickSubtitle(person, occupiedStylistIds) {
  const occupied = occupiedStylistIds?.has?.(String(person?.id));
  if (occupied) return 'With another guest';
  if (person?.desk_label) return person.desk_label;
  return staffRoleLabel(person?.role);
}
